import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type { Account } from '@/types/AccountType';

export const accountService = {
  /**
   * Devuelve la lista de accounts (wallets ligadas a cada moneda) del usuario.
   * @returns ApiResult con el array de cuentas de la empresa autenticada
   */
  getAccounts(): Promise<ApiResult<Account[]>> {
    return executeRequest(() =>
      http.get<Account[]>('product-gateway/b2b/account')
    );
  },
};
